import { waitForElements, headerTransition, updateBodyPaddingTop, getElementOrParentByClassName } from '../helpers/utils';
import { renderWishlistCounter } from '../services/wishlist.service';
import Scroll from './Scroll';
import { Carousel } from './Carousel';
import IsMobile from './IsMobile';
import { whenOverlayShown } from './Overlay';
import { SEARCH_CLOSE } from '../constants/events.constants';
export default (($) => {
    console.log('UNTUCKit : Module : Nav : loaded');
    let navOpen = false;
    const $wrapAll = $('html,body');
    function close() {
        if (navOpen) {
            $('.js-nav').removeClass('is-active');
            $wrapAll.removeClass('nav-opened');
            $(".m-menu__checkbox").prop("checked", false);
            Scroll.unlock();
            navOpen = false;
        }
    }
    function open() {
        if (!navOpen) {
            $('.js-nav').addClass('is-active');
            $wrapAll.addClass('nav-opened');
            Scroll.lock();
            navOpen = true;
        }
    }
    const bindUIActions = function () {
        console.log('bindUIActions');
        $('.js-nav').on('touchmove', function (e) {
            e.stopPropagation();
        });
        $('.js-nav').on('click', function () {
            if (!IsMobile.check())
                close();
        });
        $('.js-show-nav').off('click').on('click', function () {
            toggle();
            return false;
        });
        document.addEventListener('click', function (e) {
            const target = e.target;
            if (getElementOrParentByClassName(target, 'js-hide-nav')) {
                close();
            }
        });
        // desktop and mobile carousels are rendered at different times
        waitForElements(".mobile-nav .js-utk-carousel").then((els) => handleCarousels(els, "mobile")).catch(() => { });
        const bottomBar = document.querySelector(".header__bottom-bar");
        headerTransition.subscribe((smallerHeader) => {
            if (smallerHeader) {
                if (bottomBar) {
                    const bottomBarHeight = bottomBar.offsetHeight;
                    updateBodyPaddingTop(bottomBarHeight);
                    bottomBar.classList.add("header__bottom-bar--hidden");
                }
            }
            else if (bottomBar) {
                bottomBar.classList.remove("header__bottom-bar--hidden");
            }
        });
        whenOverlayShown.subscribe(() => close());
        document.addEventListener('click', (e) => {
            const target = e.target;
            // close mobile nav when chat link is clicked
            if (getElementOrParentByClassName(target, 'open_chat') && target.closest('.mobile-nav')) {
                e.preventDefault();
                close();
            }
        });
    };
    function toggle() {
        if ($('.nav-opened').length) {
            close();
        }
        else {
            open();
        }
    }
    function init() {
        console.log('UNTUCKit : Module : Nav : init');
        bindUIActions();
        renderWishlistCounter();
    }
    return { init };
})($);
function handleCarousels(els, device) {
    Array.from(els).forEach((el) => {
        new Carousel(el, { rotation: el.dataset.rotation }, device).setup();
    });
}
document.addEventListener("click", handleMobileMenuBackClick);
document.addEventListener("click", handleMobileSearchIconClick);
document.addEventListener("click", handleDesktopSearchIconClick);
document.addEventListener(SEARCH_CLOSE, handleDesktopSearchFormCloseClick);
function handleMobileSearchIconClick(e) {
    const target = e.target;
    const searchButton = getElementOrParentByClassName(target, "header-actions__search-button-mobile");
    if (searchButton) {
        const mobileSearchFormContainer = document.querySelector(".header__mobile-search-form-container");
        if (mobileSearchFormContainer) {
            searchButton.classList.toggle('header-actions__search-button-mobile--active');
            mobileSearchFormContainer.classList.toggle('header__mobile-search-form-container--open');
            if (mobileSearchFormContainer.classList.contains('header__mobile-search-form-container--open')) {
                mobileSearchFormContainer.removeAttribute('inert');
                const searchForm = mobileSearchFormContainer.querySelector('input');
                if (searchForm) {
                    searchForm.focus();
                }
            }
            else {
                mobileSearchFormContainer.setAttribute('inert', '');
            }
        }
    }
}
function handleMobileMenuBackClick(e) {
    const menuToggleEl = getElementOrParentByClassName(e.target, 'm-menu__toggle');
    if (menuToggleEl) {
        const inputId = menuToggleEl.dataset.inputId;
        if (inputId) {
            const inputEl = document.getElementById(inputId);
            if (inputEl) {
                inputEl.checked = false;
            }
        }
    }
}
function handleDesktopSearchIconClick(e) {
    const target = e.target;
    const searchButton = getElementOrParentByClassName(target, "header-actions__search-button-desktop");
    if (searchButton) {
        const parent = searchButton.parentElement;
        const searchFormContainer = parent.querySelector(".header-actions__search-form-container");
        if (searchFormContainer) {
            searchButton.classList.toggle('header-actions__search-button-desktop--active');
            if (searchFormContainer.classList.contains('header-actions__search-form-container--hidden')) {
                searchFormContainer.classList.remove('header-actions__search-form-container--hidden');
                searchFormContainer.removeAttribute('inert');
                const searchForm = parent.querySelector('search-form');
                if (searchForm) {
                    searchForm.setFocus();
                }
                else {
                    const searchInput = parent.querySelector('input');
                    if (searchInput) {
                        searchInput.focus();
                    }
                }
            }
            else {
                document.dispatchEvent(new CustomEvent(SEARCH_CLOSE));
            }
        }
    }
}
function handleDesktopSearchFormCloseClick() {
    const searchFormContainer = document.querySelector(".header-actions__search-form-container");
    if (searchFormContainer) {
        searchFormContainer.classList.add("header-actions__search-form-container--hidden");
        searchFormContainer.setAttribute('inert', '');
    }
    const searchButton = document.querySelector(".header-actions__search-button-desktop");
    if (searchButton) {
        searchButton.focus();
    }
}
